import { getFingerprint } from '@thumbmarkjs/thumbmarkjs';
import { isLocalhostEnvironment } from './utils';
// SINGLETON ALERT!
let fingerprintDeviceId;
export async function calcFingerprintDeviceId() {
    if (!fingerprintDeviceId) {
        const startMs = performance.now();
        fingerprintDeviceId = await getFingerprint();
        if (isLocalhostEnvironment()) {
            console.log(`Device ID done, took ${(performance.now() - startMs).toLocaleString()}ms`);
        }
    }
    return fingerprintDeviceId;
}
export function getFingerprintDeviceId() {
    return fingerprintDeviceId;
}
